<a (click)="gameClicked()" class="game-card">
    <img src="{{ game?.thumbnailDesktopRectangular?.url }}" />
    <div>{{game?.name}}</div>
</a>